export const DIAL_MODE_SIMUL = 0
export const DIAL_MODE_RAND = 1
export const DIAL_MODE_ROUND = 2
export const DIAL_MODE_LONGEST_AVAILABLE = 3
